import Card from '@components/Card';
import { getColumn } from '@utils/columns';
import { getRatingCSSColor } from '@utils/rating';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { LoginStatePart, PermissionsStatePart, SettingStatePart } from '../../setup/types';
import { HydratedEntity } from '../../types';
import { enablePerform3 } from '../settings/reducer';

const totalRating = getColumn('totalRating');
const totalRatingV2 = getColumn('totalRatingV2');
const totalRatingV3 = getColumn('totalRatingV3');
const electricForesightedDrivingPercentage = getColumn('electricForesightedDrivingPercentage');

export const Total = ({
    entity,
    shouldUseV2Ratings,
    shouldUseV3Ratings,
    isElectricVehicle = false,
}: {
    entity: HydratedEntity;
    shouldUseV2Ratings: boolean;
    shouldUseV3Ratings: boolean;
    isElectricVehicle: boolean;
}): JSX.Element => {
    let column;
    if (isElectricVehicle) {
        column = electricForesightedDrivingPercentage;
    } else if (shouldUseV3Ratings) {
        column = totalRatingV3;
    } else if (shouldUseV2Ratings) {
        column = totalRatingV2;
    } else {
        column = totalRating;
    }

    const value = column?.valueExtractor(entity) as number;
    const { color } = getRatingCSSColor(value);
    const labelId = isElectricVehicle ? 'rating.electric' : 'rating.fuel';

    return (
        <Card
            title={<FormattedMessage id={labelId} />}
            score={
                <span className={cn('text-size-12 text-bold', color)}>
                    <span className="text-size-200pct"> {column?.formatter(value)} </span>
                </span>
            }
        />
    );
};

export const mapStateToProps = (state: SettingStatePart & PermissionsStatePart & LoginStatePart) => ({
    shouldUseV2Ratings: enablePerform3(state),
});

export default connect(mapStateToProps)(Total);
